module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.ctnSheet) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search"
    },
    model: {
      value: (_vm.searchCtnSheets),
      callback: function($$v) {
        _vm.searchCtnSheets = $$v
      },
      expression: "searchCtnSheets"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.ctnSheetItems,
      "loading": _vm.gettingCtnSheets,
      "search": _vm.searchCtnSheets,
      "item-key": "id",
      "pagination": _vm.ctnPagination,
      "headers": _vm.ctnSheetHeaders
    },
    on: {
      "update:pagination": function($event) {
        _vm.ctnPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.rejected ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.ctnSheet = props.item.key;
              _vm.ctnContacts = props.item.contacts;
              _vm.ctnSheetNote = props.item.note;
              _vm.qnq = props.item.qnq;
              _vm.customerPO = props.item.customerPO;
              _vm.ctnSheetDocs = props.item.attachedDocs;
              _vm.selectedTemplates = props.item.selectedTemplates
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.BDM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("lastNote")(props.item.note)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDateTime")(props.item.LastActionDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.LastActionUser))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteOrderObj = props.item;
              _vm.deleteModal = true
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": props.item.rejected ? 'grey darken-4' : 'pink'
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }], null, false, 3005699392)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.newVehicleData.length > 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.ctnSheet = null;
        _vm.newVehicleData = []
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saving,
      "disabled": _vm.submittingCtnSheet || _vm.updating || _vm.rejecting
    },
    on: {
      "click": function($event) {
        _vm.saveDialog = true
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.newVehicleData,
      "hide-actions": "",
      "loading": _vm.gettingVehicleData,
      "search": _vm.searchVehicleData,
      "item-key": "id",
      "pagination": _vm.pagination,
      "headers": _vm.vehicleDataHeaders
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : ''],
            style: (header.align ? 'text-align:' + header.align : ''),
            on: {
              "click": function($event) {
                return _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("arrow_upward")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(header.text))])], 1)
        }), 0), _vm._v(" "), _c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : '', header.class && header.class.indexOf('group-header') !== -1 ? 'group-header' : ''],
            style: (header.align ? 'text-align:' + header.align : '')
          }, [(header.class && header.class.indexOf('group-header') !== -1 && header.hasExtras) ? _c('v-btn', {
            attrs: {
              "small": "",
              "icon": "",
              "flat": header.class && header.class.indexOf('show') === -1,
              "color": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.toggleGroup(header.value)
              }
            }
          }, [_c('v-icon', {
            staticClass: "group-hide-icon",
            attrs: {
              "color": header.class && header.class.indexOf('show') === -1 ? 'primary' : 'white'
            }
          }, [_vm._v("add")])], 1) : _vm._e()], 1)
        }), 0)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [(props.index === 0) ? _c('tr', [_c('td'), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template, index) {
          return [_c('td', {
            key: 'checkAll-' + index,
            staticClass: "text-xs-center"
          }, [_c('v-checkbox', {
            staticClass: "text-xs-center",
            attrs: {
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeInstalledDeviceAll(template.id)
              }
            },
            model: {
              value: (_vm.allItemsInstalledDevices[template.id]),
              callback: function($$v) {
                _vm.$set(_vm.allItemsInstalledDevices, template.id, $$v)
              },
              expression: "allItemsInstalledDevices[template.id]"
            }
          })], 1), _vm._v(" "), _vm._l((template.extras), function(templateExtra, extraIndex) {
            return [(templateExtra.permissions.sales === 'write') ? _c('td', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (template.visible),
                expression: "template.visible"
              }],
              key: 'x-' + index + '-' + extraIndex,
              class: (!_vm.allItemsInstalledDevices[template.id] ? 'grey lighten-2 ' : '') + 'col-' + template.id
            }, [(_vm.allItemsInstalledDevices[template.id] && templateExtra.permissions.sales === 'write') ? _c('v-edit-dialog', {
              attrs: {
                "return-value": _vm.allItems[template.id][templateExtra.name],
                "large": "",
                "lazy": "",
                "persistent": ""
              },
              on: {
                "update:returnValue": function($event) {
                  return _vm.$set(_vm.allItems[template.id], templateExtra.name, $event)
                },
                "update:return-value": function($event) {
                  return _vm.$set(_vm.allItems[template.id], templateExtra.name, $event)
                },
                "save": function($event) {
                  return _vm.changeExtraAll(template.id, templateExtra.name)
                }
              }
            }, [_c('div', [_vm._v(_vm._s(_vm.allItems[template.id][templateExtra.name]))]), _vm._v(" "), (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice') ? _c('v-select', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "items": _vm.selectedTemplates[index]['extras'][extraIndex]['options'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true,
                "clearable": _vm.selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            }) : (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'text') ? _c('v-text-field', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "text",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            }) : _c('v-text-field', {
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "number",
                "step": _vm.selectedTemplates[index]['extras'][extraIndex]['step'],
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (_vm.allItems[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(_vm.allItems[template.id], templateExtra.name, $$v)
                },
                expression: "allItems[template.id][templateExtra.name]"
              }
            })], 1) : [_vm._v(_vm._s(_vm.allItems[template.id][templateExtra.name]))]], 2) : _vm._e()]
          })]
        })], 2) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
          style: (['cursor:pointer;', props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;']),
          on: {
            "click": function($event) {
              return _vm.updateVehicleRegDialog(props.item.id)
            }
          }
        }, [_vm._v(_vm._s(props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template, index) {
          return [_c('td', {
            key: props.item.id + '-' + index,
            staticClass: "text-xs-center"
          }, [_c('v-checkbox', {
            staticClass: "text-xs-center",
            attrs: {
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeInstalledDevice(props.item.id, template.id)
              }
            },
            model: {
              value: (props.item.installedDevices[template.id]),
              callback: function($$v) {
                _vm.$set(props.item.installedDevices, template.id, $$v)
              },
              expression: "props.item.installedDevices[template.id]"
            }
          })], 1), _vm._v(" "), _vm._l((template.extras), function(templateExtra, extraIndex) {
            return [(templateExtra.permissions.sales === 'write') ? _c('td', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (template.visible),
                expression: "template.visible"
              }],
              key: props.item.id + '-' + index + '-' + extraIndex,
              class: (props.item.installedDevices[template.id] && props.item.devices[template.id] && props.item.devices[template.id][templateExtra.name] === '' ? 'blue lighten-4 ' : '') + (!props.item.installedDevices[template.id] ? 'grey lighten-2 ' : '') + 'col-' + template.id,
              staticStyle: {
                "border": "solid 1px #eee!important"
              }
            }, [(props.item.devices[template.id] && templateExtra.permissions.sales === 'write') ? _c('v-edit-dialog', {
              ref: 'edit-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "return-value": props.item.devices[template.id][templateExtra.name],
                "large": "",
                "lazy": "",
                "persistent": ""
              },
              on: {
                "update:returnValue": function($event) {
                  return _vm.$set(props.item.devices[template.id], templateExtra.name, $event)
                },
                "update:return-value": function($event) {
                  return _vm.$set(props.item.devices[template.id], templateExtra.name, $event)
                },
                "open": function($event) {
                  _vm.openEditDialog(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))
                },
                "save": function($event) {
                  _vm.nextRow(props.index, templateExtra.name.replace(new RegExp(' ', 'g'), '@'))
                }
              }
            }, [_c('div', [_vm._v(_vm._s(props.item.devices[template.id][templateExtra.name]))]), _vm._v(" "), (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'choice') ? _c('v-select', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "items": _vm.selectedTemplates[index]['extras'][extraIndex]['options'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true,
                "clearable": _vm.selectedTemplates[index]['extras'][extraIndex]['default'] === '' ? true : false
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            }) : (_vm.selectedTemplates[index]['extras'][extraIndex]['type'] === 'text') ? _c('v-text-field', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "text",
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            }) : _c('v-text-field', {
              ref: 'input-' + templateExtra.name.replace(new RegExp(' ', 'g'), '@') + '-' + props.index,
              refInFor: true,
              attrs: {
                "slot": "input",
                "autofocus": "",
                "single-line": "",
                "type": "number",
                "step": _vm.selectedTemplates[index]['extras'][extraIndex]['step'],
                "label": _vm.selectedTemplates[index]['extras'][extraIndex]['name'],
                "required": _vm.selectedTemplates[index]['extras'][extraIndex]['required'] === true
              },
              slot: "input",
              model: {
                value: (props.item.devices[template.id][templateExtra.name]),
                callback: function($$v) {
                  _vm.$set(props.item.devices[template.id], templateExtra.name, $$v)
                },
                expression: "props.item.devices[template.id][templateExtra.name]"
              }
            })], 1) : [_vm._v(_vm._s(props.item.devices[template.id] ? props.item.devices[template.id][templateExtra.name] : ''))]], 2) : _vm._e()]
          })]
        })], 2)]
      }
    }], null, false, 2107887689)
  }, [_vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "error",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n          Your search for \"" + _vm._s(_vm.searchVehicleData) + "\" found no results.\n        ")])], 1), _vm._v(" "), (_vm.role === 'Sales') ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.updating,
      "disabled": _vm.saving || _vm.submittingCtnSheet || _vm.rejecting
    },
    on: {
      "click": function($event) {
        _vm.updateDialog = true
      }
    }
  }, [_vm._v("Update")])], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "error",
      "loading": _vm.rejecting,
      "disabled": _vm.saving || _vm.updating || _vm.submittingCtnSheet
    },
    on: {
      "click": function($event) {
        _vm.rejectDialog = true;
      }
    }
  }, [_vm._v("Reject")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.submittingCtnSheet,
      "disabled": _vm.saving || _vm.updating || _vm.rejecting
    },
    on: {
      "click": function($event) {
        _vm.acceptDialog = true;
      }
    }
  }, [_vm._v("Accept")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Note: ")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.ctnSheetNote)
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(Object.keys(_vm.finance).length > 0) ? _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v("Finance")]), _vm._v(" "), _vm._l((_vm.selectedTemplates), function(template) {
    return _c('div', {
      key: template.id,
      staticClass: "my-3"
    }, [_c('h4', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('v-select', {
      attrs: {
        "multiple": "",
        "items": _vm.paymentMethods,
        "chips": "",
        "label": "Payment Method(s)"
      },
      model: {
        value: (_vm.finance[template.id]['paymentMethods']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'paymentMethods', $$v)
        },
        expression: "finance[template.id]['paymentMethods']"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Contact Term",
        "items": _vm.contractTerms
      },
      model: {
        value: (_vm.finance[template.id]['contractTerm']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'contractTerm', $$v)
        },
        expression: "finance[template.id]['contractTerm']"
      }
    }), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Currency",
        "items": _vm.currencies
      },
      model: {
        value: (_vm.finance[template.id]['currency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'currency', $$v)
        },
        expression: "finance[template.id]['currency']"
      }
    }), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('upfront-payment')) ? _c('v-text-field', {
      attrs: {
        "label": "Upfront Payment",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['upfrontPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'upfrontPayment', $$v)
        },
        expression: "finance[template.id]['upfrontPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('upfront-installation')) ? _c('v-text-field', {
      attrs: {
        "label": "Installation Payment",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['installationPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'installationPayment', $$v)
        },
        expression: "finance[template.id]['installationPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('rental')) ? _c('v-text-field', {
      attrs: {
        "label": "Rental Payment",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['rentalPayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'rentalPayment', $$v)
        },
        expression: "finance[template.id]['rentalPayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('rental')) ? _c('v-select', {
      attrs: {
        "label": "Rental Frequency",
        "items": _vm.rentalFrequencies
      },
      model: {
        value: (_vm.finance[template.id]['rentalFrequency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'rentalFrequency', $$v)
        },
        expression: "finance[template.id]['rentalFrequency']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-select', {
      attrs: {
        "label": "lessor",
        "items": _vm.lessors
      },
      model: {
        value: (_vm.finance[template.id]['lessor']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'lessor', $$v)
        },
        expression: "finance[template.id]['lessor']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-text-field', {
      attrs: {
        "label": "Lease Payment",
        "type": "number",
        "prefix": _vm.currencySymbolFromVal(_vm.finance[template.id]['currency']),
        "step": "0.01"
      },
      model: {
        value: (_vm.finance[template.id]['leasePayment']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'leasePayment', $$v)
        },
        expression: "finance[template.id]['leasePayment']"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.finance[template.id]['paymentMethods'].includes('lease')) ? _c('v-select', {
      attrs: {
        "label": "Lease Frequency",
        "items": _vm.leaseFrequencies
      },
      model: {
        value: (_vm.finance[template.id]['leaseFrequency']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'leaseFrequency', $$v)
        },
        expression: "finance[template.id]['leaseFrequency']"
      }
    }) : _vm._e(), _vm._v(" "), _c('v-select', {
      attrs: {
        "label": "Warranty",
        "items": _vm.warranties
      },
      model: {
        value: (_vm.finance[template.id]['warranty']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'warranty', $$v)
        },
        expression: "finance[template.id]['warranty']"
      }
    }), _vm._v(" "), (_vm.finance[template.id]['warranty'] !== 'n/a') ? _c('v-select', {
      attrs: {
        "label": "Warranty Type",
        "items": _vm.warrantyType
      },
      model: {
        value: (_vm.finance[template.id]['warrantyType']),
        callback: function($$v) {
          _vm.$set(_vm.finance[template.id], 'warrantyType', $$v)
        },
        expression: "finance[template.id]['warrantyType']"
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-start": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Attached Documents")]), _vm._v(" "), _c('upload-btn', {
    attrs: {
      "title": 'Attach New Document',
      "fileChangedCallback": _vm.attachFile
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("mdi-paperclip")])], 1)], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', _vm._l((_vm.ctnSheetDocs), function(doc) {
    return _c('v-list-tile', {
      key: doc.name
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "color": "error",
        "disabled": _vm.deletingCtnSheetDoc
      },
      on: {
        "click": function($event) {
          return _vm.deleteCtnSheetDoc(doc.name)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "href": doc.downloadUrl,
        "target": "_BLANK"
      }
    }, [_vm._v(_vm._s(doc.name))])])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-list', _vm._l((_vm.attachedDocs), function(fileObj, key) {
    return _c('v-list-tile', {
      key: fileObj.file.name,
      attrs: {
        "two-line": ""
      }
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "color": "error",
        "disabled": _vm.submittingCtnSheet
      },
      on: {
        "click": function($event) {
          return _vm.attachedDocs.splice(key, 1)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(fileObj.file.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption ml-1"
    }, [_vm._v(_vm._s(_vm._f("formatBytes")(fileObj.file.size)))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('v-progress-linear', {
      attrs: {
        "value": fileObj.Progress,
        "color": fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'
      }
    })], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.rejectDialog),
      callback: function($$v) {
        _vm.rejectDialog = $$v
      },
      expression: "rejectDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Reject CTN Sheet")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": "Note"
    },
    model: {
      value: (_vm.rejectNote),
      callback: function($$v) {
        _vm.rejectNote = $$v
      },
      expression: "rejectNote"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.submittingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        _vm.rejectDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "flat": "",
      "loading": _vm.rejecting,
      "disabled": _vm.rejecting
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("Reject")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.acceptDialog),
      callback: function($$v) {
        _vm.acceptDialog = $$v
      },
      expression: "acceptDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Accept CTN Sheet")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": "Note"
    },
    model: {
      value: (_vm.acceptNote),
      callback: function($$v) {
        _vm.acceptNote = $$v
      },
      expression: "acceptNote"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.suppliers,
      "label": "Assign to Supplier",
      "item-text": "name",
      "item-value": "key"
    },
    model: {
      value: (_vm.projectSupplier),
      callback: function($$v) {
        _vm.projectSupplier = $$v
      },
      expression: "projectSupplier"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.submittingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.submittingCtnSheet,
      "disabled": _vm.submittingCtnSheet
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.updateDialog),
      callback: function($$v) {
        _vm.updateDialog = $$v
      },
      expression: "updateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update CTN Sheet")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": "Note"
    },
    model: {
      value: (_vm.updateNote),
      callback: function($$v) {
        _vm.updateNote = $$v
      },
      expression: "updateNote"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.submittingCtnSheet
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.updating,
      "disabled": _vm.updating
    },
    on: {
      "click": _vm.updateCtnSheet
    }
  }, [_vm._v("Update")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.saveDialog),
      callback: function($$v) {
        _vm.saveDialog = $$v
      },
      expression: "saveDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Save CTN Sheet")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "3",
      "label": "Note"
    },
    model: {
      value: (_vm.saveNote),
      callback: function($$v) {
        _vm.saveNote = $$v
      },
      expression: "saveNote"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.saving
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.updating,
      "disabled": _vm.updating
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Update")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.vehicleRegDialog),
      callback: function($$v) {
        _vm.vehicleRegDialog = $$v
      },
      expression: "vehicleRegDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Vehicle Registration")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "updateVehicleRegInput",
    attrs: {
      "label": "Vehicle Reg.",
      "autofocus": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveVehicleReg($event)
      }
    },
    model: {
      value: (_vm.vehicleRegDialogData.Reg),
      callback: function($$v) {
        _vm.$set(_vm.vehicleRegDialogData, "Reg", $$v)
      },
      expression: "vehicleRegDialogData.Reg"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": ""
    },
    on: {
      "click": _vm.saveVehicleReg
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.vehicleRegDialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.deleteModal),
      callback: function($$v) {
        _vm.deleteModal = $$v
      },
      expression: "deleteModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete Order")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Are you sure you wish to delete order " + _vm._s(_vm.deleteOrderObj.id) + "?\n        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "flat": "",
      "loading": _vm.deletingOrder
    },
    on: {
      "click": _vm.deleteOrder
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteModal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9e30ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderApproval.vue
// module id = 766
// module chunks = 1